import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useViewContext from '@modules/order/hooks/use-view-context'
import get from 'lodash/get'
import last from 'lodash/last'
import split from 'lodash/split'
import { useObserver } from 'mobx-react-lite'
import React, { FC, useMemo } from 'react'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import HierarchyCell from '../../components/HierarchyCell'
import Typography from '@components/std-components/Typography'
import formatNumberByLocale from '@utils/format-number-by-locale'

const HierarchyKPIDetails: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    const numberFields = [
      'salesQuantity',
      'averageWeeklySales',
      'forecastAverageWeeklySales',
      'avgDepth',
      'forecastAvgDepth'
    ]
    const { uiStore } = useViewContext()
    const hierarchy = uiStore.getHierarchy(rowData.name)
    const kpiField = useMemo(
      () => `kpis.${last(split(column.field, '.'))}`,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [column.field]
    )
    if (!rowData) {
      return (
        <HierarchyCell>
          <FieldSkeleton />
        </HierarchyCell>
      )
    }
    return (
      <HierarchyCell>
        <Typography variant='subHeading1'>
          {numberFields.includes(last(split(kpiField, '.')))
            ? formatNumberByLocale(get(last(hierarchy), kpiField) || 0, 2)
            : formatNumberByLocale(get(last(hierarchy), kpiField) || 0)}
        </Typography>
      </HierarchyCell>
    )
  })

export default HierarchyKPIDetails
